<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "DocumentPickerV1Properties",
  props: ["formId"],
  async mounted() {
    this.fetchFormBuilderForms({ category: "main" });
  },
  methods: {
    ...mapActions("formBuilder", ["fetchFormBuilderForms"])
  },
  computed: {
    ...mapState("formBuilder", {
      formOptions: state =>
        [...state.list["main"],
         ...state.list["groupSession"],
         ...state.list["masterTreatmentPlan"]]
          .map(f => ({
            value: f.id,
            text: f.name
          }))
          .sort((a, b) =>
            a.text.toLowerCase().localeCompare(b.text.toLowerCase())
          )
    }),
    fields() {
      return [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "checkbox",
          properties: {
            label: "Show Effective Date"
          },
          property: "showEffectiveDate"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "textInput",
          properties: {
            label: "Default value"
          },
          property: "value"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "dropdown",
          properties: {
            label: "Form",
            options: this.formOptions
          },
          property: "formId"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "checkbox",
          properties: {
            label: "Exclude from Paste content"
          },
          property: "excludeFromPasteContent"
        },
        {
          type: "checkbox",
          properties: {
            label: "Hide in view mode"
          },
          property: "hideOnView"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        },
        {
          type: "autopopulation",
          properties: {
            label: "Autopopulation"
          },
          property: "onChange"   
        },
        {
          type: "multipleText",
          properties: {
            label: "Exclude document statuses from options",
            allowCollection: false
          },
          property: "excludeDocumentStatusesFromOptions"
        }
      ];
    }
  }
};
</script>

<style></style>
